import type { Client } from '@zg-rentals/http-client';
import { CometUserAuthenticationWebHandler_getUser_queryOptions } from '@zg-rentals/ts-your-rental-api-client-react-query';
import { client } from './rentalClient';
import { defineAuthProvider } from '@zg-rentals/auth-react';
import { isAuthorized } from '@zg-rentals/auth-comet';
import { zillowRedirectLogin } from '@zg-rentals/login-zillow/client';

export const Auth = defineAuthProvider({
  queryOptions: ({ httpClient = client }: { httpClient?: Client }) =>
    CometUserAuthenticationWebHandler_getUser_queryOptions({ pageWithSensitiveInformation: true }, { httpClient }),

  isAuthorized: isAuthorized({ mapUser: (user) => user, requireStrongAuthentication: true }),
});

export const { useAuth } = Auth;

export const redirectToLogin = (redirectPath: string) =>
  zillowRedirectLogin({ baseURL: process.env.NEXT_PUBLIC_AUTH_BASE_URL, entryPoint: 'your-rental-web', redirectPath });
